import { FaFacebook, FaInstagram } from "react-icons/fa";
import * as SocialProviders from "../../../_constants/SocialProvider";

export const STEPS = {
  start: "start",
  customize: "customize",
  customize_advance: "customize_advance",
  result: "result",
};

export const BACKGROUND_TYPES = {
  color: "color",
  gradient: "gradient",
  image: "image",
};

export const BACKGROUND_COLOR_PRESETS = [
  "#F5A623",
  "#F8E71C",
  "#8B572A",
  "#7ED321",
  "#417505",
  "#BD10E0",
  "#9013FE",
  "#4A90E2",
  "#50E3C2",
  "#B8E986",
  "#000000",
  "#4A4A4A",
  "#9B9B9B",
  "#FFFFFF",
];

export const BACKGROUND_GRADIENT_PRESETS = [
  "linear-gradient(135deg, #7928ca, #ff0080)",
  "linear-gradient(135deg, #fec206, #ff62a7)",
  "linear-gradient(135deg, #667eea, #764ba2)",
  "linear-gradient(120deg, #f6d365, #fda085)",
  "linear-gradient(120deg, #e0c3fc, #8ec5fc)",
  "linear-gradient(90deg, #4facfe, #00f2fe)",
  "linear-gradient(90deg, #ffecd2, #fcb69f)",
  "linear-gradient(120deg, #a1c4fd, #c2e9fb)",
  "linear-gradient(135deg, #f5f7fa, #c3cfe2)",
  "linear-gradient(180deg, #fddb92, #d1fdff)",
  "linear-gradient(180deg, #fad0c4, #ffd1ff)",
  "linear-gradient(180deg, #a8edea, #fed6e3)",
  "linear-gradient(180deg, #ff9a9e 0%, #fecfef 99%, #fecfef 100%)",
  "linear-gradient(180deg, #30cfd0, #330867)",
  "linear-gradient(180deg, #fbc2eb, #a6c1ee)",
  "linear-gradient(120deg, #fccb90, #d57eeb)",
  "linear-gradient(90deg, #ff8177 0%, #ff8c7f 21%, #f99185 52%, #b12a5b 100%)",
  "linear-gradient(180deg, #fdcbf1 0%, #fdcbf1 10%, #e6dee9 100%)",
  "linear-gradient(120deg, #f093fb, #f5576c)",
  "linear-gradient(90deg, #fa709a, #fee140)",
  "linear-gradient(90deg, #43e97b, #38f9d7)",
  "linear-gradient(180deg, #cfd9df, #e2ebf0)",
  "linear-gradient(135deg, #fdfcfb, #e2d1c3)",
  "linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%)",
  "linear-gradient(120deg, #84fab0, #8fd3f4)",
  "linear-gradient(180deg, #a18cd1, #fbc2eb)",
  "linear-gradient(180deg, #9890e3, #b1f4cf)",
  "linear-gradient(120deg, #d4fc79, #96e6a1)",
  "linear-gradient(120deg, #a6c0fe, #f68084)",
  "linear-gradient(135deg, #fec206 2.24%, #59c3ff 50.72%, #ff62a7 96.25%)"
];

export const CARD_THEME_TYPES = {
  dark: "dark",
  light: "light",
};

export const CARD_THEMES = {
  [CARD_THEME_TYPES.dark]: {
    background: "#1E1E1E",
    color: "#fff",
    messageLinkColor: "#1da1f2",
  },
  [CARD_THEME_TYPES.light]: {
    background: "#fff",
    color: "#000",
    messageLinkColor: "#1da1f2",
  },
};

export const SIZES = [
  {
    id: "instagram_post",
    icon: <FaInstagram color="#e53c5f" />,
    width: 1080,
    height: 1080,
  },
  {
    id: "instagram_story",
    icon: <FaInstagram color="#e53c5f" />,
    width: 1080,
    height: 1920,
  },
  {
    id: "instagram_reel",
    icon: <FaInstagram color="#e53c5f" />,
    width: 1080,
    height: 1920,
  },
  {
    id: "facebook_post",
    icon: <FaFacebook color="#4267b2" />,
    width: 1200,
    height: 630,
  },
  {
    id: "facebook_story",
    icon: <FaFacebook color="#4267b2" />,
    width: 1080,
    height: 1920,
  },
];

export const TEMPLATES = [ // @TODO add real templates
  {
    id: "1",
    card: {
      themeColor: CARD_THEME_TYPES.dark,
      cornerRadius: 1,
      shadow: 1,
      width: 1.3,
      scale: 1.2,
    },
    background: {
      type: BACKGROUND_TYPES.gradient,
      value: "linear-gradient(135deg, #fec206, #ff62a7)",
    },
  },
  {
    id: "2",
    card: {
      themeColor: CARD_THEME_TYPES.light,
      cornerRadius: 1,
      shadow: 1,
      width: 1.3,
      scale: 1.2,
    },
    background: {
      type: BACKGROUND_TYPES.gradient,
      value: "linear-gradient(135deg, #fec206, #ff62a7)",
    },
  },
];

export const DEFAULT_CARD_CONFIG = {
  themeColor: CARD_THEME_TYPES.dark,
  cornerRadius: 1,
  shadow: 1,
  width: 1.3,
  scale: 1.2,
};

export const DEFAULT_BACKGROUND_CONFIG = {
  type: BACKGROUND_TYPES.gradient,
  value: "linear-gradient(135deg, #fec206, #ff62a7)",
};

export const DEFAULT_SIZE_CONFIG = {
  width: 1280,
  height: 1280,
};

export const DEFAULT_TEMPLATE_DATA = {
  name: "Simplified",
  nickname: "@sosimplified",
  avatarUrl: "https://tldrprod.s3.amazonaws.com/usetldr/111399/planner/accounts/287.jpg",
  message: "We just surpassed 1,000,000 registered users on Simplified🎉  Thank you for your support!! ❤️\n\n👉 Let us know in the comments what your favorite part of Simplified is! https://t.co/Q8GgvM7m3E",
  provider: SocialProviders.TWITTER,
  tweetUrl: "https://twitter.com/sosimplified/status/1527046408313790464",
};
